import cn from 'classnames';
import type { MessageImagePayload } from 'models';
import { Image } from 'ui';
import { ChatMessageBubbleImageItem } from './chat-message-bubble-image-item';
import { useImageLayout } from './hooks';

type P = {
  images: MessageImagePayload[];
};

const ChatMessageBubbleImages = ({ images }: P) => {
  const kind = useImageLayout(images);

  if (!kind) {
    return null;
  }

  return (
    <Image.PreviewGroup>
      <div
        className={cn('chat-message-bubble-images', {
          'chat-message-bubble-images--double': kind === 'double',
          'chat-message-bubble-images--overflow': kind === 'overflow',
          'chat-message-bubble-images--quad': kind === 'quad',
          'chat-message-bubble-images--single': kind === 'single',
          'chat-message-bubble-images--triple': kind === 'triple',
        })}
      >
        {images.map((image, index) => (
          <ChatMessageBubbleImageItem
            hidden={kind === 'overflow' ? index >= 3 : false}
            image={image}
            key={image.ref}
            overlayCount={kind === 'overflow' && index === 2 ? images.length - 2 : undefined}
          />
        ))}
      </div>
    </Image.PreviewGroup>
  );
};

export default ChatMessageBubbleImages;
